<template>
    <section id="section">
        <div class="dancer-info-box cb">
            <div class="dancer-avatar-box">
                <img class="dancer-avatar" v-lazy="{src: studio.thumb, error: 'https://img.vhiphop.com/web/loading-1.gif', loading: 'https://img.vhiphop.com/web/loading-1.gif'}" alt="avatar">
            </div>
            <div class="dancer-nico-box fl">
                <div class="dancer-nico">{{studio.name}}</div>
                <div class="dancer-resume ellipsis">{{studio.digest}}</div>
            </div>

            <div class="dancer-follow bg fr" @click="follow" v-show="!studio.is_follow">关注</div>
            <div class="dancer-follow unfollow fr" @click="unfollow" v-show="studio.is_follow">取消关注</div>

            <ul class="dancer-counts-box">
                <li class="dancer-counts">
                    <div class="dancer-counts-item fl">
                        <p class="dancer-counts-number">{{studio.videos}}</p>
                        <p class="dancer-counts-describe">视频</p>
                    </div>
                    <i class="right-line fl"></i>
                </li>
                <li class="dancer-counts">
                    <div class="dancer-counts-item fl">
                        <p class="dancer-counts-number">{{$view(studio.views)}}</p>
                        <p class="dancer-counts-describe">播放</p>
                    </div>
                    <i class="right-line fl"></i>
                </li>
                <li class="dancer-counts">
                    <div class="dancer-counts-item fl">
                        <p class="dancer-counts-number">{{studio.fans}}</p>
                        <p class="dancer-counts-describe">关注</p>
                    </div>
                </li>
            </ul>
        </div>


        <div class="tab-lists-container">
            <div class="tab-title-container">

                <ul class="tab-lists-title-box">
                    <li class="tab-lists-title">
                        <router-link :class="`tab-lists-link${$route.name === 'studioVideo' ? ' router-link-active' : ''}`" :to="`/studios/${id}`" exact>视频</router-link>
                    </li>

                    <li class="tab-lists-title">
                        <router-link class="tab-lists-link" :to="`/studios/${id}/dancers`">舞者</router-link>
                    </li>

                    <li class="tab-lists-title">
                        <router-link class="tab-lists-link" :to="`/studios/${id}/stores`">门店</router-link>
                    </li>

                    <li class="tab-lists-title">
                        <router-link class="tab-lists-link" :to="`/studios/${id}/info`">资讯</router-link>
                    </li>
                </ul>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>

        <router-view :videoTotal="studio.videos" :dancerTotal="studio.dancers" :storeTotal="studio.stores" :infoTotal="studio.info"></router-view>
    </section>
</template>

<script>
    export default {
        data: () => ({
            studio: {
                name: '',
                thumb: '',
                digest: '',
                views: 0,
                fans: 0,
                videos: 0,
                counts: 0,
                is_follow: false,
            },
            is_following: false,
        }),
        computed: {
            id() {
                return +this.$route.params.id || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            },
            uid() {
                return this.$store.state.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
        },
        watch: {
            uid() {
                this.api.get(`studios/${this.id}/follow`).then(e => this.studio.is_follow = !!e, this.err);
            }
        },
        methods: {
            follow() {// 关注工作室
                if (this.is_following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.studio.is_follow = true;
                this.studio.fans++;
                this.is_following = true;
                this.api.post(`studios/${this.id}/follow`).then(() => this.is_following = false, () => {
                    this.studio.is_follow = false;
                    this.studio.fans--;
                    this.is_following = false;
                    this.alert.err(e.message);
                });
            },
            unfollow() {// 取消关注
                if (this.is_following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.confirm({
                    title: '取消关注',
                    content: `确认要取消关注该工作室吗?`,
                    sureCb: async () => {
                        this.is_following = true;
                        this.studio.is_follow = false;
                        this.studio.fans--;
                        await this.api.del(`studios/${this.id}/follow`).catch(e => {
                            this.studio.is_follow = true;
                            this.studio.fans++;
                            this.is_following = false;
                            this.alert.err(e.message);
                        });
                        this.is_following = false;
                    }
                });
            }
        },
        beforeMount() {
            let {id, page} = this;

            this.api.get(`studios/${id}`, {page}).then(e => this.studio = e, this.err);
        },
    }
</script>

<style scoped>
    @import "../../../static/css/views/dancer/detail.css";
    @import "../../../static/css/common/tab.css";

    .dancer-info-box {
        margin-bottom: 0;
        border-bottom-color: transparent;
    }

    .dancer-avatar {
        border-radius: 3px;
    }
    .dancer-avatar-box {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/studio/Detail.vue